var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-wrapper--navbar"},[_c('el-container',[_c('el-main',{staticClass:"d--grid"},[_c('el-menu',{attrs:{"default-active":_vm.defaultIndex,"mode":"horizontal"}},[(_vm.isCountry)?_c('el-menu-item',{attrs:{"index":"trips"}},[_c('nuxt-link',{attrs:{"to":{
              name: _vm.type === 'country' ? 'search-country' : 'search-type',
              params: {
                type: _vm.$t(`router.search_type.type.${_vm.type}`),
                value: _vm.value,
                tab: _vm.$t('router.search_type.tab.trips'),
                travelTo: _vm.$t('router.search_type.travel_to_'),
              },
            }}},[(_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.title.information`)))]):_c('span',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.country_information`)))])])],1):_vm._e(),_vm._v(" "),_c('el-menu-item',{attrs:{"index":"tours"}},[_c('nuxt-link',{attrs:{"to":_vm.type !== 'country'
                ? {
                    name: 'search-type',
                    params: {
                      type: _vm.$t(`router.search_type.type.${_vm.type}`),
                      value: _vm.value,
                      tab: _vm.$t('router.search_type.tab.tours'),
                    },
                  }
                : { name: 'search', query: _vm.$route.query }}},[(_vm.isMobile)?_c('span',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.title.experiences`)))]):(!!_vm.type && !!_vm.header.name)?_c('span',[_vm._v("\n              "+_vm._s(_vm.$t(`${_vm.base}.title.${_vm.type}`, { name: _vm.header.name }))+"\n            ")]):_c('span',[_vm._v(_vm._s(_vm.$t(`${_vm.base}.meta.title`)))])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }